/** @jsxImportSource react */
'use client';

import Link from 'next/link';

import type { ReactNode } from 'react';

import { track } from './analytics';

/** Client wrapper that fires a PostHog event on click. */
export function TrackedLink({
  children,
  className,
  event,
  external = false,
  href,
  properties,
  rel = 'noopener',
}: {
  event: string;
  properties?: Record<string, unknown>;
  href: string;
  className?: string;
  /** Open in a new tab for links that leave the marketing funnel. */
  external?: boolean;
  /** `rel` for external links. Defaults to `noopener`; pass `noreferrer` to
   *  also withhold the referrer. Ignored when `external` is false. */
  rel?: string;
  children: ReactNode;
}) {
  const onClick = () => track(event, properties);

  if (external) {
    return (
      <a
        className={className}
        href={href}
        rel={rel}
        target="_blank"
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <Link className={className} href={href} onClick={onClick}>
      {children}
    </Link>
  );
}
